import { CoreAPI, createAPIMethod, createCommonMemberMethods } from '@hero/sdk-core';
import { MemberDriversAPI } from '@hero/api';

export function createMembersAPI(coreAPI: CoreAPI) {
  return {
    /**
     * Get drivers (members with driver type)
     *
     * API: {@link MemberDriversAPI}
     */
    getDrivers: createAPIMethod<MemberDriversAPI>(coreAPI, 'member.getDrivers'),

    // Common member methods (available across all SDKs)
    ...createCommonMemberMethods(coreAPI),
  };
}
